import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import TopNav from "@/components/site/TopNav";
import SiteFooter from "@/components/site/SiteFooter";
import HomePage from "@/pages/HomePage";
import CapabilitiesPage from "@/pages/CapabilitiesPage";
import SectorsPage from "@/pages/SectorsPage";
import FeaturedPage from "@/pages/FeaturedPage";
import LeadershipPage from "@/pages/LeadershipPage";
import ContactPage from "@/pages/ContactPage";
import ScrollToTop from "@/components/site/ScrollToTop";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background">
        <TopNav />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/sectors" element={<SectorsPage />} />
            <Route path="/featured" element={<FeaturedPage />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <SiteFooter />
        <Toaster position="top-right" richColors closeButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
